import Typography from '@mui/material/Typography';

const StandardTitle = ({ title }: { title: string }) => {
  return <Typography variant="subtitle2">{title}</Typography>;
};

export default StandardTitle;
